// ** Redux **
import { IRootState } from '@redux/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ** Types **
export type TokenSliceType = {
  token: null | string;
  refreshToken: null | string;
  sessionStart?: number | null;
  isLogin?: boolean;
};

const initialState: TokenSliceType = {
  token: null,
  refreshToken: null,
  sessionStart: null,
  isLogin: false,
};

const slice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setToken(state: TokenSliceType, action: PayloadAction<TokenSliceType>) {
      state.token = action.payload.token;
      state.sessionStart = Math.floor(Date.now() / 1000);
      state.refreshToken = action.payload.refreshToken;
    },
    clearToken(state: TokenSliceType) {
      state.token = null;
      state.refreshToken = null;
      state.sessionStart = null;
    },
    setLogin(state: TokenSliceType) {
      state.isLogin = true;
    },
    unsetLogin(state: TokenSliceType) {
      state.isLogin = false;
    },
  },
});

export const { reducer } = slice;

export const { setToken, clearToken, setLogin, unsetLogin } = slice.actions;

export const getAuthToken = (state: IRootState) => state.token.token;
export const getRefreshToken = (state: IRootState) => state.token.refreshToken;
export const getSessionStart = (state: IRootState) => state.token.sessionStart;
export const getIsLoginStatus = (state: IRootState) => state.token.isLogin;

export default slice;
